<script>
export default {
  name: 'UserDetailStatisticTileItem',
  props: {
    label: String,
    icon: String,
    value: [String, Number],
    title: String,
  },
};
</script>

<template lang="pug">
.b-user-detail-statistic-tile-item
  ._tile
    ._tile-header
      ._tile-label {{label }}
      Icon(:name="icon")
    ._tile-value
      ._tile-value-count {{ value }}
      ._tile-value-title {{ title }}
</template>

<style scoped lang="scss">
.user-detail-statistic-tile-item {
  width: 100%;

  &__tile {
    box-sizing: border-box;
    min-width: 206px;
    width: 100%;
    padding: 15px 17px 19px 17px;
    background-color: rgba(248, 249, 252, 1);
    border-radius: 8px;
  }

  &__tile-header {
    display: flex;
    //align-items: flex-start;
    justify-content: space-between;
    height: 34px;
  }

  &__tile-label {
    color: rgb(30, 49, 71);
    font-family: Geometria, sans-serif;
    font-size: 12px;
    font-weight: 400;
    line-height: 15px;
    letter-spacing: normal;
    text-align: left;
    padding-top: 5px;
  }

  &__tile-value {
    display: flex;
    align-items: flex-end;
    gap: 6px;
  }

  &__tile-value-count {
    color: rgb(30, 49, 71);
    font-family: Geometria, sans-serif;
    font-size: 32px;
    font-weight: 500;
    line-height: 32px;
    letter-spacing: normal;
    text-align: left;
  }

  &__tile-value-title {
    color: rgb(146, 160, 176);
    font-family: Geometria, sans-serif;
    font-size: 12px;
    font-weight: 400;
    line-height: 15px;
    letter-spacing: normal;
    text-align: center;
  }
}
</style>
